import React from 'react';

import { Location } from '_lib/api/apiTypes.shim';

import { MenuItem } from '_lib/components/MenuItem/MenuItem';
import { TextField } from '_lib/components/TextField/TextField';
import { Typography } from '_lib/components/Typography/Typography';
import { formatAddressTwoLine } from '_lib/utils/helpers';
import { FieldIssueProps } from '_lib/utils/validationErrorUtils';
export interface LocationSelectProps extends FieldIssueProps {
  onSetLocation: (locationProviderId: string) => void;
  disabled: boolean;
  location?: Location;
  locations?: Location[];
  required?: boolean;
}

export const LocationSelect = (props: LocationSelectProps) => {
  const { onSetLocation, disabled, issuePath, issues, location, locations, required } = props;

  return (
    <TextField
      fullWidth
      label='Service Location'
      required={required}
      disabled={disabled}
      value={location?.providerId || ''}
      defaultValue={''}
      select
      error={{
        issues,
        issuePath
      }}
      onChange={(e) => {
        if (e.target.value) onSetLocation(e.target.value);
      }}>
      {locations &&
        locations.length > 0 &&
        locations.map((location: Location) => (
          <MenuItem key={location.providerId} value={location.providerId}>
            <Typography sx={{ whiteSpace: 'pre-line' }} text={`${location.name}\n ${formatAddressTwoLine(location)}`} />
          </MenuItem>
        ))}
      {(!locations || locations.length === 0) && <MenuItem disabled>No Locations found.</MenuItem>}
    </TextField>
  );
};
